import { useState } from "react";
import { channelItems } from "@/mocks/communityData";
import SectionTitle from "./SectionTitle";

export default function Channels() {
  const [followed, setFollowed] = useState<string[]>([]);

  const toggleFollow = (name: string) =>
    setFollowed((prev) => (prev.includes(name) ? prev.filter((x) => x !== name) : [...prev, name]));

  return (
    <section id="channels" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionTitle
          eyebrow="按兴趣分圈"
          title="六大频道，总有一圈适合你"
          desc="不同圈子有不同的瓜，关注你感兴趣的频道，专属讨论与更新第一时间推给你。"
        />

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {channelItems.map((ch) => {
            const isFollow = followed.includes(ch.name);
            return (
              <article
                key={ch.name}
                className="group rounded-2xl border border-background-200 bg-background-50 p-5 transition hover:-translate-y-0.5 hover:border-accent-300 hover:bg-accent-50/30"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-700 transition group-hover:bg-accent-500 group-hover:text-background-50">
                    <i className={`${ch.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <button
                    type="button"
                    onClick={() => toggleFollow(ch.name)}
                    className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition ${
                      isFollow
                        ? "bg-accent-500 text-background-50"
                        : "border border-accent-200 text-accent-700 hover:bg-accent-100/70"
                    }`}
                  >
                    <i className={`${isFollow ? "ri-check-line" : "ri-add-line"} text-sm`} aria-hidden="true"></i>
                    {isFollow ? "已关注" : "关注频道"}
                  </button>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{ch.name}</h3>
                <p className="mt-1 text-sm text-foreground-600">{ch.desc}</p>
                <div className="mt-4 flex items-center gap-2 border-t border-background-100 pt-3 text-xs text-foreground-500">
                  <i className="ri-community-line" aria-hidden="true"></i>
                  <span>{ch.count} 个热门话题围观中</span>
                  <a
                    href="#forum"
                    className="ml-auto inline-flex items-center gap-0.5 whitespace-nowrap font-medium text-accent-700 hover:text-accent-600"
                  >
                    进圈
                    <i className="ri-arrow-right-s-line text-sm" aria-hidden="true"></i>
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}